import { layout, moduleRoute } from '@src/helper/routes'
import type { GlobalContext } from '@src/types/GlobalContext'

export default (cntx: GlobalContext) => {
    const router = cntx.router
}
